import Box from '@mui/material/Box'

const Embellishment = () => 
  <Box
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      backgroundImage: `url(${process.env.PUBLIC_URL}/hive-texture.svg)`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom left',
      height: 230,
      width: 415,
    }}
  />

export default Embellishment